module.exports = __webpack_public_path__ + "static/lock-checkbox-41320d76cad034e55efe0f9312cce951.gif";